"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reducer = exports.combine = exports.toKeys = void 0;
const sanitise = (s) => {
    s = s[s.length - 1] === '.' ? s.substr(0, s.length - 1) : s;
    s = s[0] === "'" ? s.substr(1) : s;
    s = s[s.length - 1] === "'" ? s.substr(0, s.length - 1) : s;
    return s;
};
const regex = /(?:'([^']*)'|([^.]*))[.]?/g;
const toKeys = (str) => {
    const matches = str.match(regex);
    return matches
        .filter(z => z)
        .map(z => sanitise(z))
        .map(z => {
        const params = z.split('=');
        if (params.length > 2) {
            throw new Error('Cannot understand the key string');
        }
        if (params.length === 2) {
            return {
                uniqueField: params[0],
                key: params[1],
            };
        }
        const match = /\[(\d+)\]/.exec(z);
        if (match) {
            return {
                uniqueField: 'index',
                key: match[1],
            };
        }
        return {
            key: z,
        };
    });
};
exports.toKeys = toKeys;
const fetchIndexWithKey = (obj, key) => {
    let index;
    if (key.key === 'index') {
        index = parseInt(key.key);
    }
    else if (key.uniqueField) {
        index = obj.findIndex(z => z[key.uniqueField] === key.key);
    }
    if (index > -1 && index < obj.length) {
        return index;
    }
    return -1;
};
const fetchWithKey = (obj, key) => {
    if (Array.isArray(obj)) {
        const index = fetchIndexWithKey(obj, key);
        if (index > -1) {
            return obj[index];
        }
    }
    else {
        return obj[key.key];
    }
};
const mergeIntoArray = (original, update, key) => {
    if (key.uniqueField) {
        const resolved = [...original];
        let index = fetchIndexWithKey(resolved, key);
        if (index > -1 && index < original.length) {
            if (!update) {
                resolved.splice(index, 1);
                return resolved;
            }
            resolved[index] = update;
            return resolved;
        }
        return [...resolved, update];
    }
    return original;
};
const combine = (o, f, v, options) => {
    let keys = f;
    if (typeof f === 'string') {
        keys = (0, exports.toKeys)(f);
    }
    let key;
    if (keys.length > 1) {
        const currentKey = keys[0];
        const remainingKeys = keys.slice(1);
        key = currentKey;
        v = (0, exports.combine)(fetchWithKey(o, currentKey), remainingKeys, v, options);
    }
    else if (keys.length === 1) {
        key = keys[0];
    }
    else {
        throw new Error('invalid key');
    }
    if (key) {
        if (Array.isArray(o)) {
            return mergeIntoArray(o, v, key);
        }
        else if (!Array.isArray(v) && v && typeof v === 'object') {
            return Object.assign(Object.assign({}, o), { [key.key]: Object.assign(Object.assign({}, o[key.key]), v) });
        }
        if (options === null || options === void 0 ? void 0 : options.toggle) {
            return Object.assign(Object.assign({}, o), { [key.key]: !o[key.key] });
        }
        return Object.assign(Object.assign({}, o), { [key.key]: v });
    }
};
exports.combine = combine;
const reducer = (state, action) => {
    const { field, value, toggle } = action;
    if (field) {
        const result = (0, exports.combine)(state, field, value, { toggle });
        if (result)
            return result;
    }
    const { merge } = action;
    if (merge) {
        return Object.assign(Object.assign({}, state), merge);
    }
    const { newState } = action;
    return newState !== null && newState !== void 0 ? newState : state;
};
exports.reducer = reducer;
